import { combineReducers } from 'redux';

import authReducer from '../common/reducers/auth.reducer';
import notificationReducer from '../common/reducers/notification.reducer';
import spinnerReducer from '../common/reducers/spinner.reducer';
import changePasswordReducer from '../features/account/changePassword/changePassword.reducer';
import forgotPasswordReducer from '../features/account/forgotPassword/forgotPassword.reducer';
import loginReducer from '../features/account/login/login.reducer';
import resetPasswordReducer from '../features/account/resetPassword/resetPassword.reducer';
import userReducer from '../features/users/users.reducer'
import exhibitReducer from '../features/exhibits/exhibits.reducer';
import groupVisitReducer from '../features/groupVisits/groupVisits.reducer';
import resourceReducer from '../features/visitorInformation/components/cards/facilityResources/resources.reducer';
import hoursReducer from '../features/visitorInformation/components/cards/hours/hours.reducer';
import facilityInfoReducer from '../features/visitorInformation/visitorInformation.reducer';
import appNotificationReducer from '../features/notifications/notifications.reducer';
import groupLoginReducer from '../features/groupVisits/components/summary/login/login.reducer'
import rolesReducer from '../common/reducers/roles.reducer';

const rootReducer = combineReducers({
    auth: authReducer,
    notification: notificationReducer,
    spinner: spinnerReducer,
    login: loginReducer,
    forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    changePassword: changePasswordReducer,
    users: userReducer,
    exhibits: exhibitReducer,
    groupVisits: groupVisitReducer,
    resources: resourceReducer,
    days: hoursReducer,
    facilityInfo: facilityInfoReducer,
    appNotifications: appNotificationReducer,
    groupLogin: groupLoginReducer,
    roles: rolesReducer
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;